import { atom } from 'recoil'

export const $componentLibrary = atom<string | undefined>({
  key: 'componentLibrary',
  default: undefined,
})
